import { render, staticRenderFns } from "./LastNotifications.vue?vue&type=template&id=28401af2"
import script from "./LastNotifications.vue?vue&type=script&lang=ts"
export * from "./LastNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports